import React from 'react';
import cn from 'classnames';
import type { GuideMeta } from '../types';
import { useGuideText } from '../useGuideText';
import { RoleBadges } from './RoleBadges';

export const GuideHeader: React.FC<{
  guide: GuideMeta;
  compact?: boolean;
  level?: 1 | 2 | 3;
}> = ({ guide, compact, level = 1 }) => {
  const { title, summary } = useGuideText();
  const Icon = guide.icon;
  const headingClassName = cn(
    'font-bold text-title-page-color-100 dark:text-white',
    compact ? 'text-base' : 'text-xl'
  );
  const HeadingTag = `h${level}` as unknown as 'h1' | 'h2' | 'h3';
  return (
    <header className={cn('flex flex-col gap-3', compact ? 'mb-4' : 'mb-6')}>
      <div className="flex items-start gap-3">
        <span
          className={cn(
            'flex shrink-0 items-center justify-center rounded-lg bg-blue-600 text-white shadow-sm dark:bg-blue-500',
            compact ? 'h-8 w-8' : 'h-10 w-10'
          )}
        >
          <Icon className={compact ? 'h-4 w-4' : 'h-5 w-5'} />
        </span>
        <div className="min-w-0">
          <HeadingTag className={headingClassName}>
            {title(guide.id)}
          </HeadingTag>
          <p className="mt-0.5 text-sm text-title-page-color-300 dark:text-gray-400">
            {summary(guide.id)}
          </p>
        </div>
      </div>
      <RoleBadges roles={guide.audience} />
    </header>
  );
};
